<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item label="刷手號" prop="userNum">
          {{form.userNum}}
        </a-form-model-item>
      <a-form-model-item label="暱稱" prop="nickname">
        <span>{{ form.userName }}</span>
      </a-form-model-item>
      <a-form-model-item label="反饋類型" prop="typeName">
        <span>{{ form.typeName }}</span>
      </a-form-model-item>
      <a-form-model-item label="反饋圖片" prop="avatar">
         <span  v-if="form.imgUrls != null && form.imgUrls != ''">
            <img @click="imgShow(imgUrl)" style="width: 55px;height: 55px;margin-left: 5px" preview="反饋圖片" v-for="(imgUrl, index) in form.imgUrls.split(',')" :src="imgUrl" v-if="form.imgUrls != null && form.imgUrls != ''">
          </span>
        <span v-else>
            暫無圖片
          </span>
      </a-form-model-item>
      <a-form-model-item label="反饋內容" prop="content">
        <span>{{ form.content }}</span>
      </a-form-model-item>
      <a-form-model-item label="反饋時間" prop="createTime">
        <span>{{ form.createTime }}</span>
      </a-form-model-item>
      <a-form-model-item label="處理狀態" prop="processStatus" >
        <a-select v-model="form.processStatus" placeholder="處理狀態">
          <a-select-option :value="2">已處理</a-select-option>
          <a-select-option :value="3">暫不處理</a-select-option>
          <a-select-option :value="4">無效</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="意見反饋選項"  prop="noticeStatus">
        <a-select v-model="form.auditTypeId" placeholder="請選擇下架原因選項">
          <a-select-option v-for="item in auditTypeList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="處理結果" prop="processResult" >
        <a-input v-model="form.processResult" placeholder="請輸入處理結果" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUserFeedback, addUserFeedback, updateUserFeedback } from '@/api/platform/userFeedback'
import Editor from '@/components/Editor'
import {imgShow} from "@/utils/ruoyi";
import {listAuditType} from "@/api/platform/video";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      auditTypeList: [],
      formTitle: '',
      // 表單參數
      form: {
        id: null,

        userId: null,

        type: null,

        content: null,

        processStatus: 0,

        processResult: null,

        imgUrls: null,

        createTime: null,

        remark: null,

        auditTypeId: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用戶id，外鍵{user.id}不能為空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '反饋類型：1-意見建議、2-故障報告、3-其他問題不能為空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    auditTypeInit(){
      listAuditType({"place":6}).then(response => {
        this.auditTypeList = response.data;
      })
    },
    imgShow(imgUrl){
      imgShow(imgUrl)
    },
    onClose () {
      this.open = false
      this.form.processStatus = 1
      this.reset();
    },
    // 取消按鈕
    cancel () {
      this.open = false
      this.form.processStatus = 1
      this.reset()
    },
    // 表單重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        content: null,
        processStatus: 0,
        auditTypeId: null,
        processResult: null,
        imgUrls: null,
        createTime: null,
        remark: null,
      }
   /*   this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })*/
    },
    /** 新增按鈕操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按鈕操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      // getUserFeedback({"id":id}).then(response => {
      //   this.form = response.data
      //   this.form.processStatus = 2
      //   this.open = true
      //   this.formTitle = '修改'
      // })
      this.form = row
      this.form.processStatus = 2
      this.open = true
      this.formTitle = '修改'
      this.auditTypeInit();
    },
    /** 提交按鈕 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUserFeedback(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUserFeedback(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
